import { convertTimestampToLuxonOrDefaultNow } from "../utils/convertTimestampToLuxonOrDefaultNow";
export function assertUserStatus(status) {
    if (!["active", "inactive"].includes(status)) {
        throw new Error("UserType.status must be one of: active, inactive");
    }
}
export const assertUserType = (data, mode = "load") => {
    if (!data || typeof data !== "object") {
        throw new Error("UserType must be an object");
    }
    const user = data;
    // Required fields based on mode
    const requiredFields = mode === "save"
        ? ["name", "status", "uid"]
        : [
            "id",
            "name",
            "firstName",
            "lastName",
            "status",
            "uid",
            "createdAt",
            "modifiedAt",
        ];
    for (const field of requiredFields) {
        if (!(field in user)) {
            throw new Error(`UserType is missing required field: ${field}`);
        }
    }
    // Type checks
    if (mode === "load" && typeof user.id !== "string") {
        throw new Error("UserType.id must be a string");
    }
    if (typeof user.name !== "string") {
        throw new Error("UserType.name must be a string");
    }
    if (typeof user.firstName !== "string") {
        throw new Error("UserType.firstName must be a string");
    }
    if (typeof user.lastName !== "string") {
        throw new Error("UserType.lastName must be a string");
    }
    // Validate status
    assertUserStatus(user.status);
    // Timestamp validation based on mode
    // if (mode === "load") {
    //   if (!(user.createdAt instanceof DateTime)) {
    //     throw new Error("UserType.createdAt must be a DateTime");
    //   }
    //   if (!(user.modifiedAt instanceof DateTime)) {
    //     throw new Error("UserType.modifiedAt must be a DateTime");
    //   }
    // } else {
    //   if (user.createdAt && !(user.createdAt instanceof DateTime)) {
    //     throw new Error(
    //       "UserType.createdAt must be a DateTime or FieldValue.serverTimestamp()",
    //     );
    //   }
    //   if (user.modifiedAt && !(user.modifiedAt instanceof DateTime)) {
    //     throw new Error(
    //       "UserType.modifiedAt must be a DateTime or FieldValue.serverTimestamp()",
    //     );
    //   }
    // }
    return true;
};
export function createUserType(data) {
    if (!assertUserType(data, "save")) {
        throw new Error("Invalid user data");
    }
    return data;
}
export const createUserConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(user) {
        if (!assertUserType(user, "save")) {
            throw new Error("UserType.save failed");
        }
        const { id, ...userWithoutId } = user;
        const data = {
            ...userWithoutId,
            apiVersion: 1,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(user.createdAt),
            modifiedAt: convertToFirestoreTimestampOrDefaultServerTime(user.modifiedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const user = {
            ...data,
            id: snapshot.id,
            apiVersion: 1,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            modifiedAt: convertTimestampToLuxonOrDefaultNow(data.modifiedAt),
        };
        if (!assertUserType(user, "load")) {
            throw new Error("UserType.load failed");
        }
        return user;
    },
});
//# sourceMappingURL=UserType.js.map